/* AME hero banners — no library, no jQuery.
 * Controls are optional in the markup: previous / next / dots (visible or
 * visually hidden until focused) and a pause-play toggle. Touch swipe and
 * Left/Right arrow keys always work. Autoplay only when the section enables
 * it AND the visitor has not asked for reduced motion; it also stops while the
 * pointer is over the hero or focus is inside it, and while the tab is hidden.
 * Inactive slides are display:none + inert so keyboard and screen-reader
 * users only ever meet the current slide.
 */
(function () {
  function init(hero) {
    if (hero.dataset.heroReady === 'true') return;
    hero.dataset.heroReady = 'true';
    var slides = Array.prototype.slice.call(hero.querySelectorAll('[data-hero-slide]'));
    if (slides.length <= 1) return;

    var status = hero.querySelector('[data-hero-status]');
    var prevBtns = Array.prototype.slice.call(hero.querySelectorAll('[data-hero-prev]'));
    var nextBtns = Array.prototype.slice.call(hero.querySelectorAll('[data-hero-next]'));
    var playBtn = hero.querySelector('[data-hero-play]');
    var dots = Array.prototype.slice.call(hero.querySelectorAll('[data-hero-dot]'));
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    var interval = parseInt(hero.dataset.interval, 10) || 8000;
    if (interval < 1000) interval = interval * 1000;
    if (interval < 4000) interval = 4000;
    var autoplayWanted = hero.dataset.autoplay === 'true';
    var paused = !autoplayWanted || reduceMotion.matches;   // user/system state
    var suspended = false;                                    // hover / focus / hidden tab
    var current = slides.findIndex(function (s) { return s.classList.contains('is-active'); });
    if (current < 0) current = 0;
    var timer = null;

    function setInert(el, on) {
      if (on) { el.setAttribute('inert', ''); el.setAttribute('aria-hidden', 'true'); }
      else { el.removeAttribute('inert'); el.removeAttribute('aria-hidden'); }
    }
    function show(index, announce) {
      var next = (index + slides.length) % slides.length;
      slides.forEach(function (s, i) {
        var on = i === next;
        s.classList.toggle('is-active', on);
        setInert(s, !on);
      });
      dots.forEach(function (d, i) {
        var on = i === next;
        d.setAttribute('aria-current', on ? 'true' : 'false');
        d.classList.toggle('is-active', on);
      });
      current = next;
      if (announce && status) status.textContent = 'Banner ' + (current + 1) + ' of ' + slides.length;
    }
    function tick() { show(current + 1, false); }
    function start() {
      if (paused || suspended || timer) return;
      timer = setInterval(tick, interval);
    }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function restart() { stop(); start(); }
    function syncPlay() {
      if (!playBtn) return;
      playBtn.setAttribute('aria-pressed', paused ? 'true' : 'false');
      playBtn.setAttribute('aria-label', paused ? 'Play slideshow' : 'Pause slideshow');
      playBtn.dataset.state = paused ? 'paused' : 'playing';
      var label = playBtn.querySelector('[data-hero-play-label]');
      if (label) label.textContent = paused ? 'Play slideshow' : 'Pause slideshow';
    }

    prevBtns.forEach(function (b) { b.addEventListener('click', function () { show(current - 1, true); restart(); }); });
    nextBtns.forEach(function (b) { b.addEventListener('click', function () { show(current + 1, true); restart(); }); });
    dots.forEach(function (d, i) { d.addEventListener('click', function () { show(i, true); restart(); }); });
    if (playBtn) {
      playBtn.addEventListener('click', function () {
        paused = !paused;
        if (paused) { stop(); } else { start(); }
        syncPlay();
      });
    }
    hero.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { show(current - 1, true); restart(); }
      if (e.key === 'ArrowRight') { show(current + 1, true); restart(); }
    });

    // Touch swipe (horizontal, > 48px, mostly horizontal)
    var touchX = null, touchY = null;
    hero.addEventListener('touchstart', function (e) {
      if (!e.touches || e.touches.length !== 1) return;
      touchX = e.touches[0].clientX; touchY = e.touches[0].clientY;
    }, { passive: true });
    hero.addEventListener('touchend', function (e) {
      if (touchX === null || !e.changedTouches || !e.changedTouches.length) return;
      var dx = e.changedTouches[0].clientX - touchX;
      var dy = e.changedTouches[0].clientY - touchY;
      touchX = touchY = null;
      if (Math.abs(dx) < 48 || Math.abs(dx) < Math.abs(dy) * 1.5) return;
      show(dx < 0 ? current + 1 : current - 1, true);
      restart();
    }, { passive: true });

    // Reading time: pointer or focus inside the hero suspends rotation.
    hero.addEventListener('mouseenter', function () { suspended = true; stop(); });
    hero.addEventListener('mouseleave', function () { suspended = false; start(); });
    hero.addEventListener('focusin', function () { suspended = true; stop(); });
    hero.addEventListener('focusout', function (e) {
      if (!hero.contains(e.relatedTarget)) { suspended = false; start(); }
    });
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) { stop(); } else { start(); }
    });
    if (reduceMotion.addEventListener) {
      reduceMotion.addEventListener('change', function (m) { if (m.matches) { paused = true; stop(); syncPlay(); } });
    }

    slides.forEach(function (s, i) { setInert(s, i !== current); });
    syncPlay();
    start();
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-ame-hero]'), init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  // Theme Editor: re-init when the section is re-rendered
  document.addEventListener('shopify:section:load', function (e) {
    var h = e.target && e.target.querySelector && e.target.querySelector('[data-ame-hero]');
    if (h) { h.dataset.heroReady = 'false'; init(h); }
  });
})();
